import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Faq
 *
 * FAQ 모델 — 스웨거 명세(TB_FAQ, v1faqfaqsidgetokresponsedata) 기준.
 * - faqNm: 제목, faqCn: 내용(HTML 가능)
 * - faqTypeSid: 유형 마스터(/v1/faq-type) SID. 유형명이 필요하면 별도 조인.
 */
export const Faq = types
  .model('Faq')
  // --------------------------------------------------------------------------
  .props({
    faqSid: types.number,
    faqNm: types.string,
    faqCn: types.string,
    faqTypeSid: types.maybe(types.number),
    srvcSid: types.maybe(types.number),
    regDt: types.maybe(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model faq --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IFaqSnapshot>) => {
      const newProps = { ...self, ...props } as IFaq;
      (Object.keys(newProps) as TFaqKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TFaq = Instance<typeof Faq>;
type TFaqSnapshot = SnapshotOut<typeof Faq>;

export interface IFaq extends TFaq {}
export type TFaqKeys = keyof TFaqSnapshot & string;
export interface IFaqSnapshot extends TFaqSnapshot {}
export const createFaq = () => types.optional(Faq, {} as TFaq);
